<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9">
      <div class="row">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header d-xl-flex justify-content-between">
              <h3>CRM</h3>
              <div>
                <base-button 
                  @click="$router.push('/solicitud-pedidos')" 
                  icon="fa fa-check"
                  type="secondary">
                  Solicitud de pedidos
                </base-button>
                <base-button 
                  @click="$router.push('/customers')" 
                  icon="fa fa-user-friends"
                  type="secondary">
                  Clientes
                </base-button>
                <base-button 
                  @click="$router.push('/cotizaciones/proyectos')"
                  icon="fa fa-clipboard-list fa-lg"
                  type="secondary">
                  Cotización de Proyectos
                </base-button>
                <base-button 
                  @click="$router.push('/explorador/ventas')"
                  icon="fa fa-chart-line fa-lg"
                  type="secondary">
                  Explorador de ventas
                </base-button>
                <base-button
                  @click="modal.returns = true"
                  icon="fa fa-undo-alt"
                  type="secondary">
                  Devoluciones
                </base-button>
              </div>
              </div>
              <div class="card-body">
                <iframe 
							  	src="https://datastudio.google.com/embed/reporting/1J1Z8O3YKUDuW_s3Oz0E8kbf99zeweVtO/page/tZyRB"
							  	width="100%" 
							  	height="1190" 
							  	frameborder="0" 
							  	allowfullscreen>
							  </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

    <b-modal hide-footer title="Devoluciones" size="xl" v-model="modal.returns" bodyClass="p-0">
      <data-table id="dt_returns" class="pb-5 mt-n2" v-bind="dtReturns"/>       
    </b-modal>
        
    <b-modal hide-footer title="Devolución" size="lg" v-model="modal.return">
      <div v-if="currentReturn" class="mt-n4">
        <div class="d-flex justify-content-between">
          <div>
            <h4 class="m-0">{{currentReturn.CardName}}</h4>
            <h5 class="text-muted m-0">{{currentReturn.CardCode}}</h5>
          </div>
          <div>
            <base-button 
              @click="finishReturn(currentReturn)"
              size="sm">
              Finalizar devolución
            </base-button>              
          </div>              
        </div>
        <hr class="my-4">
        <div class="row">
          <h5 class="col-3">Agente de ventas:</h5>
          <span class="col-9 text-xs">{{currentReturn.vendedor}}</span>
          <h5 class="col-3">Descripción del cliente:</h5>
          <span class="col-9 text-xs">{{currentReturn.descripcion_cliente}}</span>
          <h5 class="col-3">Dirección de recolección:</h5>
          <span class="col-9 text-xs">
            {{ `${currentReturn.recoleccion.calle} ${currentReturn.recoleccion.numero}, ${currentReturn.recoleccion.colonia}, ${currentReturn.recoleccion.cp}, ${currentReturn.recoleccion.municipio}, ${currentReturn.recoleccion.estado}`}}
          </span>
        </div>
        <hr class="my-4">
        <base-table thead-classes="thead-light" :data="currentReturn.articulos">
          <template v-slot:columns>
            <th>Código</th>
            <th>Descripción</th>
            <th>Cantidad</th>
            <th>Factura</th>
          </template>
          <template v-slot:default="{row}">
            <th>{{row.ItemCode}}</th>
            <th>{{row.ItemDescription}}</th>
            <th>{{row.cantidad}}</th>
            <th>{{row.factura}}</th>
          </template>
        </base-table>  
      </div>
    </b-modal>

  </div>
</template>
<script>
  import { getAuth, getIdToken } from "firebase/auth";
  import { 
    getFirestore, collection, query, where, getDocs, doc, updateDoc 
  } from "firebase/firestore";
  import DTButton from "@/components/DataTable/DTButton"
  import DTDescription from "@/components/DataTable/DTDescription"
  import DTLoader from "@/components/DataTable/DTLoader"
  import Event from "@/Event.js";

  export default {
    components: {
    },
    data() {
      return {
        user: null,
        modal:{
          returns: false,
          return:false
        },
        dtReturns: {
			  	data: [],
			  	columns: [
            { 
              title: "Cliente", 
              key: "CardName",
              component: DTDescription,
              extraData: { 
                title: "CardName", 
                description: "CardCode" 
              } 
            },
			  		{
			  			title: "Fecha",
			  			key: "fecha",
			  		},
			  		{
			  			title: "Agente Ventas",
			  			key: "vendedor",
			  		},
			  		{
			  			title: " ",
			  			sortable: false,
			  			component: DTButton,
			  			extraData: {
                text: "Detalles",
			  				idClick: "returns_details"
			  			}
			  		}
			  	],
			  	lang: "es",
			  	sortingMode: "single",
			  	showDownloadButton: false,
			  	loadingComponent: DTLoader,
			  	isLoading: true,
			  	defaultPerPage: 100,
			  	text: {
			  		previousButtonText: "❮",
			  		nextButtonText: "❯",
			  		searchText: "Buscar"
			  	},
			  },
        currentReturn: null,
      }
    },
    created(){
      const auth = getAuth();
      this.user = auth.currentUser;
      this.getReturns();
    },
    methods: {
      async getReturns() {
        try {
          const db = getFirestore();
          const devolucionesRef = collection(db, "devoluciones");
          const q = query(devolucionesRef, where("status", "==", "open"));
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            this.dtReturns.data = querySnapshot.docs.map((docSnap) => docSnap.data());
          }
          this.dtReturns.isLoading = false;
        } catch (error) {
          console.error("Error obteniendo devoluciones:", error);
        }
      },
      async finishReturn(devolucion) {
        try {
          const db = getFirestore();
          const devolucionesRef = collection(db, "devoluciones");
          const q = query(
            devolucionesRef, 
            where("CardCode", "==", devolucion.CardCode),
            where("timestamp", "==", devolucion.timestamp)
          );
          const querySnapshot = await getDocs(q);
          if (!querySnapshot.empty) {
            for (const docSnap of querySnapshot.docs) {
              const docRef = doc(db, "devoluciones", docSnap.id);
              await updateDoc(docRef, { status: "close" });
            }
            this.$swal("", "La devolución ha sido finalizada", "success");
            this.getReturns();
            this.modal.returns = false;
            this.modal.return = false;
          }
        } catch (error) {
          console.error("Error finalizando devolución:", error);
        }
      },
    },
    mounted() {
      Event.listen("Click", (row, id) =>{
        this.modal.return = true;
        this.currentReturn = row;
      });
    }
  }
</script>
<style>
  #dt_returns>.data-table-pagination {
  	grid-area: pagination / pagination / pagination / download;
  }
</style>